import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })

const post = (path, data) => {
    const uri = `${env.startpoint}/admin/lead/${path}`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}


/* LIST — the board of the pipeline with its numbers */
export const list = data => post("list", data)

/* GET — the whole card of one lead with its history */
export const get = data => post("get", data)

/* SAVE — a lead by hand or a change of its words */
export const save = data => post("save", data)

/* STAGE — move the lead along the pipeline */
export const stage = data => post("stage", data)

/* NOTE — a call or a note, with the next call */
export const note = data => post("note", data)

/* NEXT — when to call back */
export const next = data => post("next", data)

/* ASSIGN — who leads the lead */
export const assign = data => post("assign", data)

/* LINK — the point the lead became */
export const link = data => post("link", data)

/* ORGANIZATIONS — the points to link a lead to */
export const organizations = data => post("organizations", data)
